import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["cancelStarted"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { BMEventsType } from '../types';
import { MetricState } from './base-metric';
import { BasePageLoadMetric } from './base-page-load-metric';
export var PageLoadMetaMetric = /*#__PURE__*/function (_BasePageLoadMetric) {
  _inherits(PageLoadMetaMetric, _BasePageLoadMetric);
  var _super = _createSuper(PageLoadMetaMetric);
  function PageLoadMetaMetric() {
    var _this;
    _classCallCheck(this, PageLoadMetaMetric);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "activePageLoadMetric", null);
    return _this;
  }
  _createClass(PageLoadMetaMetric, [{
    key: "startPageLoad",
    value: function startPageLoad() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isInitial: false,
        cancelStarted: false
      };
      var cancelStarted = _ref.cancelStarted,
        startPageLoadParams = _objectWithoutProperties(_ref, _excluded);
      if (cancelStarted || this.state !== MetricState.STARTED) {
        _get(_getPrototypeOf(PageLoadMetaMetric.prototype), "startPageLoad", this).call(this, startPageLoadParams);
      }
    }
  }, {
    key: "setActive",
    value: function setActive(metric) {
      this.activePageLoadMetric = metric;
    }
  }, {
    key: "setDebug",
    value: function setDebug(debug) {
      this.config.debug = debug;
    }
  }, {
    key: "isDebugMode",
    value: function isDebugMode() {
      return this.config.debug;
    }
  }, {
    key: "isInitialLoad",
    value: function isInitialLoad() {
      return this.isInitial;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.activePageLoadMetric && this.activePageLoadMetric.cancel();
      _get(_getPrototypeOf(PageLoadMetaMetric.prototype), "clear", this).call(this);
    }
  }, {
    key: "include",
    value: function include(metric) {
      if (!this.config.include) {
        this.config.include = [metric];
      } else {
        this.config.include.push(metric);
      }
    }
  }, {
    key: "experimental__addExplicitTiming",
    value: function experimental__addExplicitTiming(name, timing) {
      if (this.explicitTimings === null) {
        this.explicitTimings = {};
      }
      this.explicitTimings[name] = timing;
    }
  }]);
  return PageLoadMetaMetric;
}(BasePageLoadMetric);
export var pageLoadMetaMetric = new PageLoadMetaMetric({
  type: BMEventsType.PAGE_LOAD,
  key: 'page_load_meta_metric'
});